import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorOrderView = () => {
  const transactionOrderView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/order-header/view', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
        loading(false)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          back: true,
        })
        loading(false)
      }
    })
  }, [])
  return { transactionOrderView }
}

export default InteractorOrderView
